import React, { useEffect, useState } from 'react';
import { Button, CloseButton, Navbar } from 'react-bootstrap';
import { TbArrowBarLeft } from 'react-icons/tb';
import { useNavbar } from '../../../context/DashNavbarContext';
import './FilterNavbar.css';
interface FilterNavbarProps {
  inHome?: boolean;
}
export const FilterNavbar: React.FC<FilterNavbarProps> = ({ inHome = false }) => {
  const { activeNavbar, setActiveNavbar, filterNavContent, filterNavOverlap } = useNavbar();
  const [isOpen, setIsOpen] = useState(activeNavbar === 'filter');

  useEffect(() => {
    setIsOpen(activeNavbar === 'filter');
  }, [activeNavbar]);

  const toggleNavbar = (isOpen: boolean) => {
    if (isOpen) {
      setActiveNavbar('filter');
    } else {
      setActiveNavbar(null); // Open the current navbar and close the other one if open
    }
  };

  if (!filterNavContent) return <></>;

  return (
    <Navbar
      expand={false}
      className={`d-block filter-navbar mb-3 py-0 ${inHome ? 'inhome' : ''} ${isOpen ? 'open' : ''} ${filterNavOverlap ? 'cover-sidebars' : ''}`}
    >
      <Button
        variant="primary"
        onClick={() => toggleNavbar(!isOpen)}
        className="d-none d-lg-block btn-box-shadow fs-5 filter-navbar-toggle mt-4 border-0 px-1 pb-1 pt-0"
      >
        <TbArrowBarLeft
          style={{ transform: `rotate(${!isOpen ? 0 : 180}deg)`, transition: 'all 0.6s' }}
        />
      </Button>

      <div className="h-100 overflow-y-scroll p-3">
        <div className="d-flex justify-content-between border-bottom mb-3 pb-1">
          <h5 className="text-secondary fw-bold">Filter</h5>
          <CloseButton onClick={() => toggleNavbar(false)} />
        </div>
        {filterNavContent}
      </div>
    </Navbar>
  );
};
